import React, {Component} from 'react'

import execSearchSubmit from './exec_search_submit'
import SelectBodyKeijouContainer from 'containers/site/select_body_keijou_container'
import SelectMakerContainer from 'containers/site/select_maker_container'
import SelectBodySizeContainer from 'containers/site/select_body_size_container'
import SelectTransmissionContainer from 'containers/site/select_transmission_container'
import SelectKudouhoushikiContainer from 'containers/site/select_kudouhoushiki_container'
import SelectPowerGateContainer from 'containers/site/select_power_gate_container'
import SelectNenshikiContainer from 'containers/site/select_nenshiki_container'
import SelectRunningDistanceContainer from 'containers/site/select_running_distance_container'
import SelectPriceContainer from 'containers/site/select_price_container'
import SelectStorageLocationContainer from 'containers/site/select_storage_location_container'

import SelectFreeWordContainer from 'containers/site/select_free_word_container'
import SelectEngineBarikiContainer from 'containers/site/select_engine_bariki_container'
import SelectSoldOutContainer from 'containers/site/select_sold_out_container'
import SelectBedContainer from 'containers/site/select_bed_container'

import SelectSaidaisekisairyouContainer from 'containers/site/select_saidaisekisairyou_container'
import SelectSyaryousoujuuryouContainer from 'containers/site/select_syaryousoujuuryou_container'
import SelectCabinWidthContainer from 'containers/site/select_cabin_width_container'
import SelectSuspensionContainer from 'containers/site/select_suspension_container'
import SelectNishitsunaisunLengthContainer from 'containers/site/select_nishitsunaisun_length_container'
import SelectNishitsunaisunWidthContainer from 'containers/site/select_nishitsunaisun_width_container'
import SelectNishitsunaisunHeightContainer from 'containers/site/select_nishitsunaisun_height_container'
import SelectFuelTypeContainer from 'containers/site/select_fuel_type_container'
import SelectSyaryougaisunLengthContainer from 'containers/site/select_syaryougaisun_length_container'
import SelectSyaryougaisunWidthContainer from 'containers/site/select_syaryougaisun_width_container'
import SelectSyaryougaisunHeightContainer from 'containers/site/select_syaryougaisun_height_container'
import ExpandButton from './expand_button'

const appElement = () => (
  document.getElementById('site_items_index_view_container')
)

const DetailSearchCondition = ({isOpenDetailSearchCondition}) => {
  if (!isOpenDetailSearchCondition){return null}
  return <React.Fragment>
    <div className="searchArea__inner">
      <SelectKudouhoushikiContainer />
      <SelectPowerGateContainer />
      <SelectSuspensionContainer />
      <SelectStorageLocationContainer />
    </div>
    <div className="searchArea__inner">
      <SelectNishitsunaisunLengthContainer />
      <SelectNishitsunaisunWidthContainer />
      <SelectNishitsunaisunHeightContainer />
      <SelectCabinWidthContainer />
    </div>
    <div className="searchArea__inner">
      <SelectSyaryougaisunLengthContainer />
      <SelectSyaryougaisunWidthContainer />
      <SelectSyaryougaisunHeightContainer />
      <SelectEngineBarikiContainer />
    </div>
    <div className="searchArea__inner">
      <SelectFuelTypeContainer />
      <SelectBedContainer />
      <SelectFreeWordContainer />
      <SelectSoldOutContainer />
    </div>
  </React.Fragment>
}

class SearchForm extends Component {
  constructor(props){
    super(props)
    this.state = {
      showCollapseLink: true ,
      collapseShow: '',
      isOpenDetailSearchCondition: !!document.querySelector('.searching'),
    }

    // 検索条件をクエリパラメータ ーから取得して初期化する
    this.props.actions.setupSearchFormCondition();
    document.getElementsByClassName('search_list_result_position')[0].scrollIntoView(true);
  }

  componentWillMount = () => {
    // items.jsの指示をうけて検索を実行する
    //  component初期構築時はここ
    this.execSearch(this.props)
  }

  componentWillReceiveProps = (nextProps) => {
    // items.jsの指示をうけて検索を実行する
    //  component構築後の検索はここ
    this.execSearch(nextProps)
  }

  execSearch = (props) => {
    if (props.searchFormCondition.execGetSearchItems){
      this.props.actions.getSearchItems({
        searchFormCondition: props.searchFormCondition,
      })
      this.props.actions.execGetSearchItemsComplete()
    }
  }

  handleSubmit = (e) => {
    execSearchSubmit(this.props.searchFormCondition, this.props.history, true)
    e.preventDefault()
  }

  handleClear = () => {
    this.props.actions.clearCondition()
  }

  handleExpandClicked = (e) => {
    this.setState({
      isOpenDetailSearchCondition: !(this.state.isOpenDetailSearchCondition),
    })
    e.preventDefault()
  }

  render() {
    return (
      <form onSubmit={this.handleSubmit} className="l-contents">
        <div className="searchArea">
          <div className="searchArea__inner">
            <SelectBodyKeijouContainer
              appElement={appElement()}
            />
            <SelectMakerContainer
              appElement={appElement()}
            />
            <SelectBodySizeContainer />
            <SelectTransmissionContainer />
          </div>

          <div className="searchArea__inner">
            <SelectNenshikiContainer />
            <SelectRunningDistanceContainer />
            <SelectSaidaisekisairyouContainer />
            <SelectSyaryousoujuuryouContainer />
            <SelectPriceContainer />
          </div>

          <DetailSearchCondition {...this.state}/>

          <ul className='searchArea__button'>
            <ExpandButton
              handleExpandClicked={this.handleExpandClicked}
              {...this.state}
            />
            <li className="searchArea__button__item">
              <div
                className='clear'
                onClick={this.handleClear}
              >
                {TRUCKERS.LANG.BUTTON.CLEAR_CONDITION}
              </div>
            </li>
            <li className="searchArea__button__item">
              <div
                className='moreBtn size-l primary'
                onClick={this.handleSubmit}
              >
                <i className="material-icons">search</i>
                {TRUCKERS.LANG.ITEM.LIST_SEARCH.SUBMIT}
              </div>
            </li>
          </ul>
        </div>
      </form>
    )
  }
}

export default SearchForm
